import { EncounterReportControllerApi } from "../../services";
import { useDownloadReport } from "../../hooks/use-download-report";
import { formatDateTime } from "../../utils/date-time-utility";
import {
  getConfigObject,
  getTrimmedUuid,
  getXtenantId,
} from "../../utils/utils";

export const useEncounterExportCsv = () => {
  const { download } = useDownloadReport();

  const exportEncountersCsv = (encounterUuids: string[]) => {
    const apiCall = new EncounterReportControllerApi(getConfigObject())
      .exportEncounterReport(getXtenantId(), encounterUuids, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        let csvText = new TextDecoder().decode(
          response.data as unknown as ArrayBuffer
        );
        encounterUuids.forEach((uuid) => {
          if (uuid) csvText = csvText.split(uuid).join(getTrimmedUuid(uuid));
        });
        return {
          ...response,
          data: new TextEncoder().encode(csvText)
            .buffer as unknown as typeof response.data,
        };
      });

    download({
      apiCall,
      fileName: `Patient_Encounters_Report ${formatDateTime(new Date())}.csv`,
      contentType: "text/csv",
    });
  };

  return { exportEncountersCsv };
};
